import { useMediaQuery } from '@mui/material';

export const MOBILE_LAYOUT_MAX_WIDTH = 1024;

export const mobileLayoutQuery = `(max-width:${MOBILE_LAYOUT_MAX_WIDTH}px)`;

export const desktopLayoutQuery = `(min-width:${MOBILE_LAYOUT_MAX_WIDTH + 1}px)`;

export const mobileLayoutMedia = `@media ${mobileLayoutQuery}`;

export const desktopLayoutMedia = `@media ${desktopLayoutQuery}`;

export const useMobileLayout = () => useMediaQuery(mobileLayoutQuery);

// A pointer that cannot hover — a phone or a tablet, whatever the width. Asked
// by capability rather than by breakpoint, since a narrow desktop window still
// hovers and a 1366px tablet still does not.
export const useTouchOnly = () => useMediaQuery('(hover: none)');
